(function () {
  'use strict';

  // Smooth-scroll any in-page anchor links within this section (e.g. the
  // hero CTA linking down to the product grid) instead of a hard jump.
  var scrollLinks = document.querySelectorAll('[data-skl-scroll-link]');
  scrollLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      var targetId = link.getAttribute('href');
      if (!targetId || targetId.charAt(0) !== '#') { return; }
      var target = document.querySelector(targetId);
      if (!target) { return; }
      e.preventDefault();
      var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
      if (history.pushState) {
        history.pushState(null, '', targetId);
      }
    });
  });

  // Subtle fade/rise-in as sections enter the viewport.
  var revealEls = document.querySelectorAll('.skl-reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );
    revealEls.forEach(function (el) { revealObserver.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  // Sticky mobile CTA: appear after scrolling past the hero, hide near the footer.
  var sticky = document.querySelector('[data-skl-sticky-cta]');
  if (sticky) {
    var showAfter = window.innerHeight * 0.6;
    var ticking = false;

    var update = function () {
      var scrollY = window.scrollY || window.pageYOffset;
      var nearBottom = scrollY + window.innerHeight >= document.body.scrollHeight - 80;
      if (scrollY > showAfter && !nearBottom) {
        sticky.classList.add('is-visible');
      } else {
        sticky.classList.remove('is-visible');
      }
      ticking = false;
    };

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
  }
})();
